import {

  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, delay, retryWhen, switchMap, tap } from 'rxjs/operators';
import { Utenteservice } from './utente.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from '@angular/router';
import { Apiservice } from './api.service';
import { I } from '@angular/cdk/keycodes';
import { contains, parseJSON } from 'jquery';
import { GetFilterService } from './get-filter.service';
//import { string } from '../../../node_modulesXX/postcss-selector-parser/postcss-selector-parser';

const moment = require('moment');

export function filtroToSQL(filter: any): string {
  if (!Array.isArray(filter)) return '';

  // Caso semplice: ["campo", "operatore", "valore"]
  if (filter.length === 3 && typeof filter[0] === 'string') {
    const [field, operator, value] = filter;
    switch (operator) {
      case 'contains':
        return `${field} LIKE '%${value}%'`;
      case '=':
        return `${field} = '${value}'`;
      case '<>':
        return `${field} != '${value}'`;
      case '>':
      case '<':
      case '>=':
      case '<=':
        return `${field} ${operator} '${value}'`;
      default:
        return '';
    }
  }

  // Caso composto con più condizioni e operatori logici
  let result = '';
  let i = 0;
  while (i < filter.length) {
    const item = filter[i];

    if (typeof item === 'string' && (item === 'and' || item === 'or')) {
      const logic = item.toUpperCase();
      const left = filtroToSQL(filter[i - 1]);
      const right = filtroToSQL(filter[i + 1]);
      result = `(${left} ${logic} ${right})`;
      i += 2; // salta il blocco processato
    } else if (Array.isArray(item)) {
      // se è un array dentro array (es: gruppo OR)
      const groupSQL = filtroToSQL(item);
      result = result ? `(${result} AND (${groupSQL}))` : `(${groupSQL})`;
      i++;
    } else {
      i++;
    }
  }

  return result;
}



@Injectable()
export class InterceptorService implements HttpInterceptor {
  //
  retryLimit = 2;
  attempt = 0;
  angularRoute;
  public href: string = "";
  constructor(private appService: Apiservice, private spinner: NgxSpinnerService, private userservice: Utenteservice, private activatedRoute: ActivatedRoute, private getFilter: GetFilterService) {
    let myThis = this;

  }

  ngOnInit() {
    //this.href = this.router.url;
    //this.angularRoute = this.loc.href();
    //const url = window.location.href;
    //const domainAndApp = url.replace(angularRoute, '');

  }

replaceAndWithHexAnd(value: string): string {
    if (!value) return value;
    const regex = /\band\b/gi;
    const hexAnd = "§§§";
    return value.replace(regex, hexAnd);
}
replaceAndWithHexOr(value: string): string {
   if (!value) return value;
    const regex = /'or/gi; // senza \b
    const hexAnd = "'@@@";
    return value.replace(regex, hexAnd);
}


  convertToSQLFilter(filter) {
    if (!Array.isArray(filter)) return '';

    if (filter.length === 3 && typeof filter[0] === 'string') {
      const [field, operator, value] = filter;
      if (operator === 'contains') {
        return `${field} LIKE '%${value}%'`;
      } else if (operator === '=') {
        return `${field} = '${value}'`;
      } else if (operator === '<>') {
        return `${field} != '${value}'`;
      }
      // altri operatori se servono
    }

    let result = '';
    let group = [];

    for (let i = 0; i < filter.length; i++) {
      const item = filter[i];

      if (typeof item === 'string' && (item.toLowerCase() === 'and' || item.toLowerCase() === 'or')) {
        const logic = item.toUpperCase();
        const left = this.convertToSQLFilter(group);
        const right = this.convertToSQLFilter(filter[i + 1]);
        return `(${left} ${logic} ${right})`;
      } else {
        group.push(item);
      }
    }

    return this.convertToSQLFilter(group[0]);
  }



  devextremeToOData(filterArray) {
    const opMap = {
      "=": "eq",
      "<>": "ne",
      ">": "gt",
      ">=": "ge",
      "<": "lt",
      "<=": "le",
      "contains": "contains",
      "notcontains": "not contains",
      "startswith": "startswith",
      "endswith": "endswith"
    };

    function escapeValue(value) {
      if (typeof value === "string") {
        // Raddoppia gli apici singoli per OData
        const escaped = value.replace(/'/g, "''");
        return `'${escaped}'`;
      }
      return value;
    }

    function parse(item) {
      if (Array.isArray(item)) {
        if (typeof item[0] === "string" && opMap[item[1]]) {
          const [field, op, value] = item;
          const odataOp = opMap[op];
          const val = escapeValue(value);

          if (
            odataOp === "contains" ||
            odataOp === "not contains" ||
            odataOp === "startswith" ||
            odataOp === "endswith"
          ) {
            return `${odataOp}(${field}, ${val})`;
          } else {
            return `${field} ${odataOp} ${val}`;
          }
        } else {
          // Gruppo logico nidificato
          return `(${item.map(parse).join(" ")})`;
        }
      } else if (typeof item === "string" && (item === "and" || item === "or")) {
        return item;
      } else {
        return "";
      }
    }

    return "$filter=" + parse(filterArray);
  }



  convertToODataFilter(filter) {
    if (!Array.isArray(filter)) return '';

    // Caso base: ["field", "operator", "value"]
    if (filter.length === 3 && typeof filter[0] === 'string') {
      const [field, operator, value] = filter;

      const opMap = {
        '=': 'eq',
        '<>': 'ne',
        '>': 'gt',
        '>=': 'ge',
        '<': 'lt',
        '<=': 'le',
        'contains': 'contains'
      };

      const odataOp = opMap[operator] || operator;
      const val = typeof value === 'string' ? `'${value}'` : value;

      return odataOp === 'contains'
        ? `contains(${field},${val})`
        : `${field} ${odataOp} ${val}`;
    }

    // Caso composito: gestisce and/or multipli
    let result = '';
    let group = [];

    for (let i = 0; i < filter.length; i++) {
      const item = filter[i];

      if (typeof item === 'string' && (item.toLowerCase() === 'and' || item.toLowerCase() === 'or')) {
        const logic = item.toLowerCase();
        const left = this.convertToODataFilter(group);
        const right = this.convertToODataFilter(filter[i + 1]);
        return `(${left} ${logic} ${right})`;
      } else {
        group.push(item);
      }
    }

    // Ricorsione per sottogruppi
    return `(${this.convertToODataFilter(group[0])})`;
  }


  intercept(req: HttpRequest<any>, next: HttpHandler)
    : Observable<HttpEvent<any>> {

    let newParams;
    const idPartner: number = 1;

    /*let httpOptions = {
      headers: new HttpHeaders().set(
        "Authorization", 'Bearer '+this.userservice.DammiToken()
      ).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      .set('Content-Type', 'application/json; charset=utf-8'), 
      params: new HttpParams()*/
    let token = this.userservice.DammiToken();
    //this.spinner.show();
    //let result = text.replace("Microsoft", "W3Schools");
    /*
      const newUrl = {url: 'new-url'};
      req = Object.assign(req, newUrl)
    */
    // Lettura Parametri


    //if(req.params && req.params['map']['take'])
    //req.params['map']['take']=parseInt(req.params['map']['take'])
    let myUrl = req.urlWithParams;
    //console.log("myUrl in string ",myUrl);   
    let strParams = req.params.toString();
    //      console.log("Params in string ",strParams);
    myUrl = strParams
    myUrl = decodeURIComponent(myUrl);
    //myUrl=myUrl.replace(/\"/g, '');     
    let stFilter = "";
    myUrl = myUrl.replace("take=", "$top=")
    myUrl = myUrl.replace("skip=", "$skip=")
    myUrl = myUrl.replace("requireTotalCount=", "$count=")
    myUrl = myUrl.replace("filter=", "$filter=")
    myUrl = myUrl.replace("sort=", "$sort=")
    // console.log("MY URL ",myUrl)
    /*
    if(localStorage.getItem(req.params.get('service'))){

      console.warn(myUrl)

      localStorage.removeItem(req.params.get('service'))
    }*/

    if (req.url.includes('/contatti') && this.userservice.InfoUtenteConnesso.tipoUtente == 10) {
      const baseUrl = req.url.split('?')[0];
      const urlParts = baseUrl.split('/');
      const contattiIndex = urlParts.indexOf('contatti');
      if (!(contattiIndex !== -1 && urlParts.length > contattiIndex + 1)) {
        const infoUser = this.userservice.InfoUtenteConnesso
        myUrl = myUrl.concat('&CodAgente=', infoUser.codiceFiscale)
      }
    }

    if (myUrl > "") {
      let ParametriFilter = null;//"$filter="
      let arrParams = myUrl.split("&");
      //unescape(encodeURIComponent(s)
      //console.log("Ecco i parametri in array ",arrParams)
      // cerco Filter
      let newP = [];
      let presumo = "and";
      arrParams.forEach(element => {
        if (element.includes("filter")) {
          console.log("Ecco il element", element)
          let newFilter = decodeURIComponent(element);
          console.log("Ecco il Filter Prima", newFilter)
          let rr = newFilter.split('$filter=');
          //let rr=JSON.parse(newFilter.split('$filter=')[0]);
          if (rr.length > 0) {

            //-------------------------------------
            console.log("Ecco array filter newArr", rr[1])
            this.getFilter.setFilterColumn(rr[1])
            let staaaaa = "";
            const parsed = JSON.parse(rr[1]);
            stFilter = this.devextremeToOData(parsed);
            //test -----------------------------------------------------
            //const sqlWhere = this.convertToSQLFilter(parsed);
            const sqlWhere = filtroToSQL(parsed);
            console.log("WHERE " + sqlWhere);

            //----------------------------------------------------------
            console.log("Ecco array filter dopo convert", stFilter)

            //----------------------------------------


            rr[1] = rr[1].replace(/\[/g, '(');
            rr[1] = rr[1].replace(/\]/g, ')');
            console.log("Ecco il Filter In Array ", rr[1])
          }

          let ArrFilter = newFilter.split("[");
          const newArr = ArrFilter.map((element, index) => {
            let a = element.replace("]", '');
            a = a.replace("]", '');
            return a.replace(/\\/g, '');
          });


          newArr.forEach(element1 => {
            let ArrFilter = element1.split(",");
            if (ArrFilter.length > 2) {
              ArrFilter[2] = ArrFilter[2].replace("|", ",")
            }
            if (ArrFilter[2]) {
              let hh = ArrFilter[2].split("T")
              if (hh.length > 1) {
                let xx = hh[0].replace(/"/g, '');
                var date = moment(xx).isValid();
                if (date) {
                  ArrFilter[2] = hh[0]
                  ArrFilter[2] = ArrFilter[2].replace("\"", "")
                }
              }

            }
            //console.log("dateeeeeeeeeeee",date)
            //console.log("Ecco ArrFilter ",ArrFilter)
            //startswith startswith
            ArrFilter[0] = ArrFilter[0].replace(/"/g, '');
            if (ArrFilter[1])
              ArrFilter[1] = ArrFilter[1].replace(/"/g, '\'');

            if (ArrFilter[2])
              ArrFilter[2] = ArrFilter[2].replace(/"/g, '\'');
            if (ArrFilter[1]) element = ArrFilter[1]; else element = element1;
            if (element.includes("notcontains")) {
              if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
              ParametriFilter += "(not contains(tolower(" + ArrFilter[0] + ")," + ArrFilter[2].toLowerCase() + "))";
            } else
              if (element.includes("contains")) {
                if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                ParametriFilter += "(contains(tolower(" + ArrFilter[0] + ")," + ArrFilter[2].toLowerCase() + "))";
              } else
                if (element.includes("startswith")) {
                  if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                  ParametriFilter += "(startswith(tolower(" + ArrFilter[0] + ")," + ArrFilter[2].toLowerCase() + "))";
                } else
                  if (element.includes("endswith")) {
                    if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                    ParametriFilter += "(endswith(tolower(" + ArrFilter[0] + ")," + ArrFilter[2].toLowerCase() + "))";
                  } else
                    if (element.includes("ge")) {
                      if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                      ParametriFilter += " " + ArrFilter[0] + " ge " + ArrFilter[2] + " ";
                    } else
                      if (element.includes("<=")) {
                        if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                        ParametriFilter += "(" + ArrFilter[0] + " le " + ArrFilter[2] + ")";
                      } else
                        if (element.includes("<")) {
                          if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                          ParametriFilter += "(" + ArrFilter[0] + " lt " + ArrFilter[2] + ")";
                        } else
                          if (element.includes(">=")) {
                            if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                            ParametriFilter += "(" + ArrFilter[0] + " ge " + ArrFilter[2] + ")";
                          } else
                            if (element.includes(">")) {
                              if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                              ParametriFilter += "(" + ArrFilter[0] + " gt " + ArrFilter[2] + ")";
                            } else
                              if (element.includes("<>")) {
                                if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                                //                  ParametriFilter+="(ne(tolower("+ArrFilter[0]+"),'"+ArrFilter[2].toLowerCase()+"'))";                 
                                //numeri            ParametriFilter+="((("+ArrFilter[0]+") ne "+ArrFilter[2].toLowerCase()+"))";
                                ParametriFilter += "((tolower(" + ArrFilter[0] + ") ne " + ArrFilter[2].toLowerCase() + "))";
                              } else
                                if (element.includes("=") && element[0] != '$') {
                                  if (ParametriFilter) ParametriFilter += " "; else ParametriFilter = "$filter=("
                                  ArrFilter[2] = ArrFilter[2].replace(/]/g, '');

                                  if (ArrFilter[2] == 'true' || ArrFilter[2] == 'false')
                                    ParametriFilter += "( " + ArrFilter[0] + " eq " + ArrFilter[2] + ") "; else

                                    ParametriFilter += "( " + ArrFilter[0] + " eq " + ArrFilter[2] + ") ";
                                }
            if (ArrFilter.length > 3) { ArrFilter[3] = ArrFilter[3].replace(/"/g, ''); ParametriFilter += " " + ArrFilter[3] + " "; }
          });
          ParametriFilter += ")";
          //ParametriFilter=ParametriFilter.replace(/"/g, '\'');
          newP.push(ParametriFilter);
        } else
          if (element.indexOf("sort") >= 0) {
            const newelement = decodeURIComponent(element);
            const parts = newelement.split("=");
            let message = parts.length > 1 ? parts[1] : "";
            let mySort = "$orderby=";

            //  Parse JSON in sicurezza
            let mioJson: any[] = [];
            try {
              mioJson = JSON.parse(message);
            } catch (err) {
              console.error("Errore nel parsing del sort:", message, err);
              mioJson = [];
            }

            //  Costruisci stringa OData
            for (let i = 0; i < mioJson.length; i++) {
              const s = mioJson[i];
              if (!s || !s.selector) continue;
              if (i > 0) mySort += ",";
              mySort += s.selector.replace(/['"]/g, "") + " " + (s.desc ? "desc" : "asc");
            }

            // Elimina eventuali $orderby già presenti
            for (let j = newP.length - 1; j >= 0; j--) {
              if (newP[j].trim().toLowerCase().startsWith("$orderby=")) {
                newP.splice(j, 1);
              }
            }

            // 🔹 Aggiungi il nuovo ordinamento
            newP.push(mySort);
          }

          else
            newP.push(element);
      });
      for (let t = 0; t < newP.length; t++) {
        // controllare per per CRMcontatti??? a fere pezzotto
        //const contattiIndex = urlParts.indexOf('contatti');
        //if(newP[t].indexOf("$filter")>-1) newP[t]=stFilter
      }

      myUrl = newP.join("&")
      myUrl = myUrl.replace(/\]/g, '');
      this.getFilter.setFilter(myUrl);
      console.log("Ecco i parametri in end point ", this.getFilter.getFilter())
    }
    //req.url=this.replaceAndWithHex(myUrl);

    
    let url = new URL(req.url, window.location.origin);

    myUrl = myUrl.replace(/&&+/g, "&");  
    if(req.url.includes('www.rentri.website')){
      
    newParams = new HttpParams({ fromString: myUrl });
    let newUrl2=this.replaceAndWithHexAnd(req.url);
    newUrl2=this.replaceAndWithHexOr(newUrl2);
    req = req.clone({url: newUrl2, params: newParams });

    }else
    req = req.clone({params: newParams });

    // --- QUI: DEDUPLICA E UNIFICA $orderby ---
    {
      const urlWithParams = req.urlWithParams;

      // procedi solo se esiste almeno un $orderby
      if (urlWithParams.includes("$orderby=")) {
        const [baseUrl, queryString] = urlWithParams.split("?");
        if (queryString) {
          const parts = queryString.split("&").filter(p => p.trim() !== "");

          // raccoglie tutti gli $orderby
          const orderBys: string[] = [];
          const otherParams: string[] = [];

          for (const p of parts) {
            if (p.toLowerCase().startsWith("$orderby=")) {
              orderBys.push(decodeURIComponent(p.replace(/^\$orderby=/i, "")));
            } else {
              otherParams.push(p);
            }
          }

          if (orderBys.length > 1) {
            // unisci e pulisci i duplicati
            const merged = orderBys.join(",");
            const segments = merged.split(",").map(s => s.trim()).filter(Boolean);

            // tieni solo l’ultimo ordine per ogni colonna
            const map = new Map<string, string>();
            for (const seg of segments) {
              const [col, dir] = seg.split(/\s+/);
              if (col) map.set(col.toLowerCase(), col + (dir ? " " + dir : ""));
            }

            const finalOrderBy = Array.from(map.values()).join(",");
            const finalQueryParts = otherParams.filter(p => !p.toLowerCase().startsWith("$orderby="));
            finalQueryParts.unshift("$orderby=" + encodeURIComponent(finalOrderBy));

            let newQuery = finalQueryParts.join("&");
            


            // 🔹 ricrea i params e clona la request
            newParams = new HttpParams({ fromString: newQuery });
            req = req.clone({
              url: baseUrl,
              params: newParams
            });

            console.log("✔️ OrderBy ripulito:", decodeURIComponent(finalOrderBy));
          }
        }
      }
    }
    // --- FINE ---

    // Clona con header e manda avanti
    console.log(this.userservice.InfoDatiUtenteConnesso.userName)
    let userCall="";
   
    if(this.userservice.InfoDatiUtenteConnesso.userName) userCall=this.userservice.InfoDatiUtenteConnesso.userName;
//quaaaaaaaaaaaaaaaaaaaa


    req = req.clone({
      setHeaders: {
        "Authorization": "Bearer " + token,
        "X-User-Call":""+userCall
      }
    });

    return next.handle(req)
      .pipe(
        retryWhen(errors => errors.pipe(delay(200),
          tap(error => {
            //console.log("RIPROVOOOOOOOOOOOOOOOO ",error)
            //console.log('attempt', this.attempt);
            if (++this.attempt >= this.retryLimit) {
              throw error;
            }
          })
        )),
        tap(evt => {
          //this.appService.parseHttpEvt(evt);
          //          console.log("EVT In Interceptor ",evt);
          //console.log("REQ In Interceptor ",req);
          //if(this.giaErrore500)          
          evt['bodyCall'] = req


          if (evt['status'] == 200) {
            //console.log("ECCOIN INTERCEPTOR ",evt)
            if (evt['body'] && evt['body']['codeMessage'] && evt['body']['codeMessage'] == -2) {
              //console.log("ddddddd "+ evt['codeMessage'])
              this.spinner.hide();
              this.appService.parseHttpEvt(evt);
            }
          }
          if (evt['status'] == 204) {
            if (!evt['body']) {
              evt['status'] == 200;
              evt['body'] = { codeMessage: 0, status: evt['status'], message: 'Ok', descrizione: "", descrMessage: 'ddddd' };
            }
          }
        }),

        catchError((error: HttpErrorResponse) => {
          this.spinner.hide();
          error['bodyCall'] = req;
          /*
          if(error.status==401 || error.status==500){
            if(this.userservice.checSessionError==false){
              //this.userservice.checSessionError=true;
              this.appService.parseHttpErrorResponse(error);
            }

            
          }
          */
          this.appService.parseHttpErrorResponse(error);

          return throwError(error);//alert(errorMsg);       
          let errorMsg = '1 ' + error.status;
          if (error.error instanceof ErrorEvent) {
            //alert('qua3');
            errorMsg = `Error: ${error.error.message}`;
            return throwError(error);// alert(errorMsg);
          }
          else {
            //alert('qua');
            let value = "";
            for (let key in error.error.errors) {
              value += error.error.errors[key];
              // Use `key` and `value`
            }
            console.log(error.error.errors);
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}` + value;
            if (error.status == 401) {
              //errorMsg="Sessione Scaduta";//error.statusText;
            }
            //return throwError(errorMsg);//alert(errorMsg);
            return throwError(error);//alert(errorMsg);
          }
        })
      )
    //--------------------------
  }
  
}
